import { jsx, jsxs, Fragment } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import useIsMobile from "../../hooks/use-is-mobile.es.js";
import { forwardRef } from "react";
import { ProductCardTitle } from "./components/product-card-title.es.js";
import Grid from "../../../node_modules/@mui/material/Grid/Grid.es.js";
import { ProductCardChip } from "./components/product-card-chip.es.js";
import { ProductCardDate } from "./components/product-card-date.es.js";
import { ProductCardDescription } from "./components/product-card-description.es.js";
import { ProductCardPrice } from "./components/product-card-price.es.js";
import { ProductCardAction } from "./components/product-card-action.es.js";
import { ProductCardContent } from "./components/product-card-content.es.js";
import { ProductCardContainer } from "./components/product-card-container.es.js";
import { PRIMARY_COLOR } from "../../foundations/constants.es.js";
import { Direction } from "../../foundations/direction.es.js";
import { Alignment } from "../../foundations/alignment.es.js";
const ProductCard = forwardRef(function ProductCard2({
  accentColor = PRIMARY_COLOR,
  title,
  price,
  date,
  badge,
  description,
  disabled = false,
  iconButtonId,
  isMobile: isMobileProp,
  isLocked,
  titleIcon,
  ...rest
}, ref) {
  const isMobileHookResult = useIsMobile();
  const isMobile = isMobileProp ?? isMobileHookResult;
  return /* @__PURE__ */ jsx(ProductCardContainer, { accentColor, disabled, isMobile, ref, ...rest, children: /* @__PURE__ */ jsxs(ProductCardContent, { isMobile, "data-testid": "card-container-content-flexed", children: [
    /* @__PURE__ */ jsxs(Grid, { container: true, wrap: "nowrap", direction: Direction.column, justifyContent: Alignment.center, alignItems: Alignment.flexStart, spacing: 2, style: {
      marginLeft: 0
    }, children: [
      /* @__PURE__ */ jsx(ProductCardChip, { accentColor, disabled, badge }),
      date ? /* @__PURE__ */ jsx(ProductCardDate, { date }) : /* @__PURE__ */ jsx(Fragment, {}),
      /* @__PURE__ */ jsx(ProductCardTitle, { title, isMobile, isLocked, disabled, accentColor, titleIcon }),
      /* @__PURE__ */ jsx(ProductCardDescription, { description }),
      /* @__PURE__ */ jsx(ProductCardPrice, { price })
    ] }),
    isMobile ? /* @__PURE__ */ jsx(Fragment, {}) : /* @__PURE__ */ jsx(ProductCardAction, { iconButtonId, disabled, isMobile })
  ] }) });
});
export {
  ProductCard
};
//# sourceMappingURL=product-card.es.js.map
